import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal } from "../components/site/Reveal";
import { Seo } from "../components/site/Seo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const FAQS = [
  { q: "How do I book?", a: "Start a booking request through this site. Tell us your idea, style, placement and size — pick an artist or let us recommend one. The studio reviews every request and follows up to confirm details and scheduling." },
  { q: "Do you require a deposit?", a: "Yes. A deposit secures your session and is applied to the final cost of your piece. Deposits are non-refundable but transferable with adequate notice." },
  { q: "What's your minimum?", a: "We have a studio minimum that covers setup, sterilization and time. Your artist will confirm pricing after reviewing your idea and reference." },
  { q: "Can I bring my own design?", a: "Absolutely. Bring reference images and ideas — our artists will refine or build a fully custom design that flows with your body and reads clean over time." },
  { q: "Do you do cover-ups?", a: "Yes. Several of our artists specialize in cover-ups and rework. Include a clear photo of the existing tattoo in your booking request." },
  { q: "How old do I have to be?", a: "You must be 18+ with a valid government-issued photo ID. No exceptions." },
  { q: "How should I prepare?", a: "Sleep well, eat beforehand, stay hydrated and avoid alcohol for 24 hours prior. Wear comfortable clothing that gives access to the placement area." },
];

export default function Faq() {
  return (
    <>
      <Seo title="FAQ" description="Frequently asked questions about booking, deposits, pricing and preparation at Obsidian Art & Tattoo Studio, Springfield VA." />
      <section className="pt-36 lg:pt-44 pb-16 max-w-[1100px] mx-auto px-6 sm:px-10 lg:px-16 border-b border-ash">
        <Reveal><p className="eyebrow mb-6">Answers</p></Reveal>
        <Reveal delay={60}><h1 className="display text-6xl sm:text-7xl lg:text-8xl text-white">FAQ.</h1></Reveal>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 sm:px-10 lg:px-16 py-16">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-ash">
              <AccordionTrigger data-testid={`faq-q-${i}`} className="font-serif text-2xl lg:text-3xl text-white hover:text-ember hover:no-underline text-left py-8">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#9E9EA8] text-base leading-relaxed pb-8 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-16 text-center">
          <Link to="/booking" className="inline-flex items-center gap-3 bg-ember text-obsidian font-mono text-xs uppercase tracking-[0.2em] font-semibold px-10 py-5 hover:bg-white transition-colors">Start a Request <ArrowRight size={15} /></Link>
        </div>
      </section>
    </>
  );
}
